module.exports = __webpack_public_path__ + "img/conseiller.8ae66a64.svg";